// extracted by mini-css-extract-plugin
export default {"container":"src-client-components-SchibstedAwarenessInfo-styles-___default__container___XO1Y3","text":"src-client-components-SchibstedAwarenessInfo-styles-___default__text___T3UP4"};